import { useAsciiText, caligraphy2 } from 'react-ascii-text';

function AsciiComponent() {
    const asciiTextRef = useAsciiText({
        animationCharacters: "▒░█",
        animationCharacterSpacing: 1,
        animationDelay: 99999999999999999,
        animationDirection: "down",
        animationInterval: 0,
        animationLoop: true,
        animationSpeed: 8,
        font: caligraphy2,
        text: ["Filth"],
      });
    
      return <pre ref={asciiTextRef} style={{ fontSize: '0.5em', lineHeight: '1.0' }}></pre>;
}

export default AsciiComponent;